import React from 'react'
import { BudgetItemList } from './list/page'

export const BudgetItemPage = () => <BudgetItemList />
